import React from 'react';
import UtilisateurCard from './UtilisateurCard';
import { Users, ChevronLeft, ChevronRight } from 'lucide-react';

const UtilisateurList = ({ 
  utilisateurs, 
  onView, 
  onChangePassword, 
  onDelete, 
  loading,
  currentPage,
  totalPages,
  onPageChange
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF6B00]"></div>
      </div>
    );
  }

  if (!utilisateurs || utilisateurs.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-12 text-center">
        <Users className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Aucun utilisateur trouvé
        </h3>
        <p className="text-gray-500">
          Aucun utilisateur ne correspond à vos critères de recherche.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Liste des utilisateurs */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
        {utilisateurs.map((utilisateur) => (
          <UtilisateurCard
            key={utilisateur.id}
            utilisateur={utilisateur}
            onView={onView}
            onChangePassword={onChangePassword}
            onDelete={onDelete}
          />
        ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100">
          <div className="flex items-center justify-between">
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                currentPage === 1
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-[#FF6B00] text-white hover:bg-[#E55A00] shadow-md hover:shadow-lg'
              }`}
            >
              <ChevronLeft className="w-5 h-5" />
              <span>Précédent</span>
            </button>

            <div className="flex items-center gap-3">
              <span className="text-sm font-medium text-gray-600">
                Page <span className="text-[#FF6B00] text-lg font-bold">{currentPage}</span> sur {totalPages}
              </span>
            </div>

            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                currentPage === totalPages
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-[#FF6B00] text-white hover:bg-[#E55A00] shadow-md hover:shadow-lg'
              }`}
            >
              <span>Suivant</span>
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UtilisateurList;
